import * as React from 'react';
import type { SVGProps } from 'react';
const SvgStreamlineHome = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={20}
    height={20}
    fill="none"
    viewBox="0 0 20 20"
    {...props}
  >
    <g
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.3}
      clipPath="url(#a)"
    >
      <path d="M1.429 9.914v7.229c0 .789.64 1.429 1.428 1.429h14.286c.789 0 1.429-.64 1.429-1.429V9.914c0-.4-.168-.782-.464-1.053L10 1.43 1.892 8.86c-.295.27-.463.653-.463 1.053M10 12.857v5.715" />
    </g>
    <defs>
      <clipPath id="a">
        <path fill="#fff" d="M0 0h20v20H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgStreamlineHome;
